// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"31d6cfe0","317":"31d6cfe0","433":"31d6cfe0","488":"31d6cfe0","569":"31d6cfe0","649":"31d6cfe0","827":"31d6cfe0","852":"31d6cfe0","958":"31d6cfe0","966":"31d6cfe0"}[chunkId] + ".chunk.css";
};